export function randomString(length) {
  let text = '';
  const possible =
    'QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnm1234567890';
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}


export function randomByDate(length) {
  let text = randomString(length);

  let date = new Date();
  let d = date.getFullYear().toString().substring(0, 2) + "_" + (date.getMonth() + 1) + "_" + date.getDate();
  return d + "_" + text;
}



export function choiceColor(): string{
  let currentArray = JSON.parse(localStorage.getItem('colorArray'));
  let currentColor = currentArray[Math.floor(Math.random() * currentArray.length)];
  if(currentArray.length === 0){
    return; 
  } else {
    currentArray = currentArray.filter(item => item !== currentColor);
    localStorage.setItem('colorArray', JSON.stringify(currentArray));
  }
  return currentColor;
  }
